"use strict";
exports.__esModule = true;
var TextareaAutosize_1 = require("./TextareaAutosize");
exports["default"] = TextareaAutosize_1.TextareaAutosize;
